export default "__VITE_ASSET__I39YnjEr__"